import { Payable, type Product } from '../@types/index.js';

export class CancelWager extends Payable {
  private _transactionId?: string;

  private _isMarketplace: boolean = false;

  private _price: number = 0;

  private _addonPrice?: number;

  private _product?: Product;

  // #competitionId;

  // private _drawNumber: number;

  get transactionId(): string | undefined {
    return this._transactionId;
  }

  get product(): Product | undefined {
    return this._product;
  }

  get price(): number {
    return this._price;
  }

  get addonPrice(): number | undefined {
    return this._addonPrice;
  }

  get isMarketplace(): boolean {
    return this._isMarketplace;
  }

  /**
   * Sets transaction id for the wager to cancel.
   *
   * @param transactionId {string}
   */
  setTransactionId(transactionId: string): void {
    this._transactionId = transactionId;
  }

  /**
   * Used for tracking.
   *
   * @param product {Product} for wager to cancel
   */
  setProduct(product: Product): void {
    this._product = product;
  }

  /**
   * Used for tracking.
   *
   * @param price {number}
   */
  setPrice(price: number): void {
    this._price = price;
  }

  /**
   * Used for tracking.
   *
   * @param addonPrice {number}
   */
  setAddonPrice(addonPrice: number): void {
    this._addonPrice = addonPrice;
  }

  /**
   * Sets if wager is marketplace.
   *
   * @param isMarketplace {boolean}
   */
  setIsMarketplace(isMarketplace: boolean): void {
    this._isMarketplace = isMarketplace;
  }

  toJSON(): Record<string, unknown> {
    return {};
  }

  toString(): string {
    return '';
  }
  // /**
  //  * Sets competition id for competition. Used for competition handler to remove drawNumber from playercompetitions
  //  * @param competitionId id for competition
  //  */
  // setCompetitionId(competitionId) {
  //   this.#competitionId = competitionId;
  // }

  // get competitionId() {
  //   return this.#competitionId;
  // }

  // /**
  //  * Used in combination with competition id to remove drawNumber from playercompetitions.
  //  *
  //  * @param drawNumber drawnumber for competition
  //  */
  // setDrawNumber(drawNumber) {
  //   this.#drawNumber = drawNumber;
  // }

  // get drawNumber() {
  //   return this.#drawNumber;
  // }
}

/**
 * Creates a new Wager instance.
 *
 * @returns - A new Wager instance.
 */
export function createCancelWager(): CancelWager {
  return new CancelWager();
}
